import React from "react";

import ObjetivoV2AccordionCard from "./ObjetivoV2AccordionCard";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

const METRICAS = [
  {
    value: "CLIENTES",
    label: "Clientes",
  },
  {
    value: "SUBMARCAS",
    label: "Submarcas",
  },
  {
    value: "QTD",
    label: "Quantidade",
  },
  {
    value: "EUROS",
    label: "Euros",
  },
  {
    value: "LITROS",
    label: "Litros",
  },
];

const MODOS_CLIENTES = [
  {
    value: "QUALQUER",
    label: "Qualquer patamar",
  },
  {
    value: "MEDIA",
    label: "Média de patamares",
  },
  {
    value: "TODAS",
    label: "Todos os patamares",
  },
];

export default function ObjetivoV2DadosGerais({
  isEdicao,
  form,
  setForm,
  nomes,
  grupos,
  nomeSelecionado,
  grupoSelecionado,
  abrirNovoNome,
  abrirEditarNome,
  abrirNovoGrupo,
  abrirEditarGrupo,
  totalDistribuido,
}) {
  const metricaSelecionada = METRICAS.find((x) => x.value === form.metrica) || null;

  const modoSelecionado = MODOS_CLIENTES.find((x) => x.value === form.patamares_modo) || null;

  const alterarMetrica = (_, value) => {
    const metrica = value?.value || "CLIENTES";

    setForm((prev) => ({
      ...prev,
      metrica,
      patamares_modo: metrica === "CLIENTES" ? prev.patamares_modo || "MEDIA" : "QUALQUER",
      ...(metrica === "SUBMARCAS"
        ? {
            valor_objetivo: "",
            valor_objetivo_manual: false,
          }
        : {}),
    }));
  };

  return (
    <ObjetivoV2AccordionCard titulo="Dados gerais" mt={0} defaultExpanded>
      <MDBox
        display="grid"
        gridTemplateColumns={{
          xs: "1fr",
          md: "repeat(2, minmax(0, 1fr))",
        }}
        gap={2}
      >
        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Nome
          </MDTypography>

          <MDBox display="flex" alignItems="center" gap={0.5}>
            <MDBox flex={1} minWidth={0}>
              <Autocomplete
                size="small"
                options={nomes}
                getOptionLabel={(option) => option?.nome || ""}
                value={nomeSelecionado}
                onChange={(_, value) =>
                  setForm((prev) => ({
                    ...prev,
                    idobjetivonome: value?.id || "",
                  }))
                }
                isOptionEqualToValue={(option, value) => String(option?.id) === String(value?.id)}
                disableClearable
                renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
              />
            </MDBox>

            <Tooltip title="Adicionar nome do objetivo">
              <IconButton size="small" onClick={abrirNovoNome}>
                <AddIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Editar nome do objetivo">
              <span>
                <IconButton
                  color="warning"
                  size="small"
                  disabled={!nomeSelecionado}
                  onClick={abrirEditarNome}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          </MDBox>
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Grupo
          </MDTypography>

          <MDBox display="flex" alignItems="center" gap={0.5}>
            <MDBox flex={1} minWidth={0}>
              <Autocomplete
                size="small"
                options={grupos}
                getOptionLabel={(option) => option?.nome || ""}
                value={grupoSelecionado}
                onChange={(_, value) =>
                  setForm((prev) => ({
                    ...prev,
                    idobjetivogrupo: value?.id || "",
                  }))
                }
                isOptionEqualToValue={(option, value) => String(option?.id) === String(value?.id)}
                disableClearable
                renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
              />
            </MDBox>

            <Tooltip title="Adicionar grupo do objetivo">
              <IconButton size="small" onClick={abrirNovoGrupo}>
                <AddIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Editar grupo do objetivo">
              <span>
                <IconButton
                  color="warning"
                  size="small"
                  disabled={!grupoSelecionado}
                  onClick={abrirEditarGrupo}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          </MDBox>
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Início
          </MDTypography>

          <MDInput
            type="date"
            fullWidth
            value={form.dataini}
            onChange={(e) =>
              setForm((prev) => ({
                ...prev,
                dataini: e.target.value,
              }))
            }
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Fim
          </MDTypography>

          <MDInput
            type="date"
            fullWidth
            value={form.datafim}
            onChange={(e) =>
              setForm((prev) => ({
                ...prev,
                datafim: e.target.value,
              }))
            }
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Métrica
          </MDTypography>

          <Autocomplete
            size="small"
            options={METRICAS}
            getOptionLabel={(option) => option?.label || ""}
            value={metricaSelecionada}
            onChange={alterarMetrica}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            disableClearable
            renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
          />
        </MDBox>

        {form.metrica === "CLIENTES" && (
          <MDBox>
            <MDTypography variant="caption" color="text" display="block" mb={0.5}>
              Modo de cálculo
            </MDTypography>

            <Autocomplete
              size="small"
              options={MODOS_CLIENTES}
              getOptionLabel={(option) => option?.label || ""}
              value={modoSelecionado}
              onChange={(_, value) =>
                setForm((prev) => ({
                  ...prev,
                  patamares_modo: value?.value || "MEDIA",
                }))
              }
              isOptionEqualToValue={(option, value) => option?.value === value?.value}
              disableClearable
              renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
            />
          </MDBox>
        )}

        {form.metrica !== "SUBMARCAS" && (
          <MDBox>
            <MDTypography variant="caption" color="text" display="block" mb={0.5}>
              Valor do objetivo
            </MDTypography>

            <MDInput
              type="number"
              fullWidth
              value={form.valor_objetivo}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  valor_objetivo: e.target.value,
                  valor_objetivo_manual: true,
                }))
              }
              inputProps={{
                min: 0,
                step: "0.001",
              }}
            />

            {Boolean(form.valor_objetivo_manual) &&
              form.valor_objetivo !== "" &&
              Number.isFinite(Number(form.valor_objetivo)) &&
              Number(form.valor_objetivo) > Number(totalDistribuido || 0) && (
                <MDTypography
                  variant="caption"
                  color="warning"
                  display="block"
                  mt={0.5}
                  fontWeight="medium"
                >
                  ⚠ Faltam{" "}
                  {(Number(form.valor_objetivo) - Number(totalDistribuido || 0)).toLocaleString(
                    "pt-PT",
                    {
                      maximumFractionDigits: 3,
                    }
                  )}{" "}
                  por distribuir pelos vendedores/equipa.
                </MDTypography>
              )}
          </MDBox>
        )}

        {isEdicao && (
          <MDBox display="flex" alignItems="center" minHeight={44}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={Number(form.inativo) === 1}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      inativo: e.target.checked ? 1 : 0,
                    }))
                  }
                  size="small"
                />
              }
              label="Inativo"
            />
          </MDBox>
        )}
      </MDBox>
    </ObjetivoV2AccordionCard>
  );
}
